import { DesignService } from '../connections';

export function pGetByAnalysisSetAndAnalysisResult(analysisSetGuid: string, analysisResultGuid: string) {
  return DesignService.fetchFile(
    `analysisCsvs/byAnalysisSet/${analysisSetGuid}/byAnalysisResult/${analysisResultGuid}`,
  );
}

export function postGenerateEngineeringReport(componentDesignGuids: string[]) {
  return DesignService.fetchFile('analysisCsvs/generateEngineeringReport', { post: true, data: componentDesignGuids });
}

export function postGenerateComprehensiveReports(componentDesignGuids: string[]) {
  return DesignService.fetchFile('analysisCsvs/generateComprehensiveReports', {
    post: true,
    data: componentDesignGuids,
  });
}
